import { del, get, post, put } from '../utils/axios'

export const getGroupsAPI = async (param) => {
  return await get('divisions',param)
}

export const createGroupsAPI = async (body) => {
  return await post('divisions', body)
}

export const updateGroupsAPI = async (param, body) => {
  return await put('divisions', param, body)
}

export const deleteGroupsAPI = async (param) => {
  return await del('divisions', param)
}

export const getOrgListAPI = async (body) => {
  return await get('org/list', body)
}

export const getGroupsExpandAPI = async (param) => {
  return await get('search/division/th-eng',param)
}
// export const getDetailGroupsAPI = async (param) => {
//   return await get('divisions/details', param).catch((error) => {
//     throw new Error(error)
//   })
// }
